/** @module Sourcing/AdoptSupplierItemToStyle */
define([
    "dojo/_base/declare",
    "csi/action/ActionView",
    "csi/action/Controller",
    "csi/comm",
    "csi/def",
    "csi/page",
    "csi/reflection",
    "csi/xml",
    "./AdoptSupplierItemToStyleForm"
], function(declare,ActionView,Controller,comm,def,page,reflection,xml,AdoptSupplierItemToStyleForm) {

    return declare(Controller, {
        /**
         * add special controller for adoption form
         * tie controller to the AdoptSupplierItemToStyleForm
         */
        getActionView: function(viewRef) {
            var rc = reflection.getClass("Style");
            var defView = def.getClassViewDef(rc, "__Form__");

            if (defView) {
                defView.classController = AdoptSupplierItemToStyleForm;
                return new ActionView(this, defView);
            }
        },

        /**
         * reset the node so the UI treats this form like a New form, so custom attributes get applied on the Style BO
         */
        onFormData: function(fd) {
            fd.setNode(null);
        },

        /**
         *  Use the unnecessary Hierarchy parameters so that they are not passed to the request
         */
        toWriterRequest: function() {
            var fd = this.getFormData();
            fd.getFieldValue("ParentSeason", true);
            fd.getFieldValue("Category1", true);
            fd.getFieldValue("Category2", true);

            var styleCNL = comm.createUrl();
            var call = this.inherited(arguments);
            call.addParameter("StyleCNL", xml.ATTR_REF, styleCNL);

            this.toWriterFields(styleCNL, fd);
        },

        _resolveStyleType: function(/*Node*/node) {
            var grandparent = this.m_cache.getPathNode(node, "Child:__Parent__/Child:__Parent__");
            if (grandparent && grandparent.$Type == "Style") {
                return grandparent.ProductType;
            } else if (grandparent && grandparent.$Type == "StyleSourcing") {
                return this.m_cache.getNode(grandparent.__Parent__).ProductType;
            } else {
                return null;
            }
        },

        /**
         *  Refresh node and breadcrumb bar since state goes from DRAFT to CLOSED
         */
        postProcessSuccess: function() {
            page.refreshRootView();
            this.widget.postActionRedrawNode(this);
        },

        /**
         * disallow Save & New in this case
         */
        _canRepeat: function() {
            return false;
        }
    });
});